import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import RedirectIfAuthenticated from "./RedirectIfAuthenticated";
import RequireAuth from "./RequireAuth";
import { ModalProvider } from "@command-center-app/context/modalContext";

const Layout = lazy(() => import("@command-center-app/layouts/Layout"));
const HomePage = lazy(() => import("@command-center-app/pages/HomePage"));
const Login = lazy(() => import("@command-center-app/pages/Auth/Login"));
const ServiceListingPage = lazy(
  () => import("@command-center-app/pages/Services/ServiceListing")
);
const ServiceDetails = lazy(
  () => import("@command-center-app/pages/Vendor/VendorDetails")
);
const ProductListingPage = lazy(
  () => import("@command-center-app/pages/Product/ProductListing")
);
const ProductDetails = lazy(
  () => import("@command-center-app/pages/Product/ProductDetails")
);
const VendorListingPage = lazy(
  () => import("@command-center-app/pages/Vendor/VendorListing")
);
const VendorDetails = lazy(
  () => import("@command-center-app/pages/Vendor/VendorDetails")
);
const VerifyToken = lazy(
  () => import("@command-center-app/pages/Auth/VerifyToken")
);

const CatalogListingPage = lazy(
  () => import("@command-center-app/pages/Catalog/CatalogListing")
);
const CatalogDetails = lazy(
  () => import("@command-center-app/pages/Catalog/CatalogDetails")
);
const CollectionListingPage = lazy(
  () => import("@command-center-app/pages/Collections/CollectionListing")
);
const CollectionDetails = lazy(
  () => import("@command-center-app/pages/Collections/CollectionDetails")
);
const SyncLogListingPage = lazy(
  () => import("@command-center-app/pages/SyncLog/SyncLogListing")
);

const AppRoutes = () => {
  return (
    <Suspense fallback={<CircularProgress size="lg" />}>
      <Routes>
        <Route
          path="/"
          element={
            <ModalProvider>
              <Layout />
            </ModalProvider>
          }
        >
          <Route path="auth">
            <Route
              path="login"
              element={
                <RedirectIfAuthenticated>
                  <Login />
                </RedirectIfAuthenticated>
              }
            />
            <Route path="verify" element={<VerifyToken />} />
          </Route>
          <Route element={<RequireAuth />}>
            <Route index element={<HomePage />} />
            <Route path="sourcing">
              <Route path="product">
                <Route index element={<ProductListingPage />} />
                <Route path=":id" element={<ProductDetails />} />
              </Route>
              <Route path="service">
                <Route index element={<ServiceListingPage />} />
                <Route path=":id" element={<ServiceDetails />} />
              </Route>
              <Route path="vendor">
                <Route index element={<VendorListingPage />} />
                <Route path=":id" element={<VendorDetails />} />
              </Route>
            </Route>
            <Route path="marketplace">
              <Route path="catalog">
                <Route index element={<CatalogListingPage />} />
                <Route path=":id" element={<CatalogDetails />} />
              </Route>
            </Route>
            <Route path="marketplace">
              <Route path="collection">
                <Route index element={<CollectionListingPage />} />
                <Route path=":id" element={<CollectionDetails />} />
              </Route>
            </Route>
            <Route path="settings">
              <Route
                path="salesforce-sync-log"
                element={<SyncLogListingPage />}
              />
            </Route>
            <Route path="*" element={<HomePage />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
